import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button, Form, Image } from 'react-bootstrap'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import CounterInput from 'react-bootstrap-counter';
import { apiUrl } from "../commons/inFormTypes"
import { IPUrl } from "../commons/IPAddress"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import Loaders from '../components/Loaders'
import NumericInput from 'react-numeric-input';


function OrderForm({ Status, order, toggle, toggleHandler1 }) {
  const [minSum, setMinSum] = useState();
  const [lstarrayInfo, setLstarrayInfo] = useState([]);
  const [snip, setSnip] = useState(false);
  const [orderchange, setOrderchange] = useState(0);
  const [codeMeli, setCodeMeli] = useState("");
  // const [name, setName] = useState("");
  // const [mobile, setMobile] = useState("");
  const [seenFile, setSeenFile] = useState([]);
  const [formIsValid, setFormIsValid] = useState("1");
  const [lstarray, setLstarray] = useState([]);
  const [master, setMaster] = useState([{
    weight: 0, coint: 0, address: "", time: "",
    Type_Area_Id: 0, Type_Area: "", day: "", date: "", stationTitle: "",
    stationAddress: "", stationId: 0,
  }]);
  const [Stchange, setstchange] = useState(false);
  const [key, setKey] = useState(false)
  const navigate = useNavigate()
  const userToken = localStorage.getItem("user_token");


  const AddListState = (val, name, id, count, score, idWeight, titleWeight, icon, minweight) => {
    const indx = lstarray.findIndex((i) => i.Type_Trash === id);
    console.log(minweight)
    if (indx < 0) {
      lstarray.push({
        Type_Trash_Tittle: name,
        Type_Trash: id,
        Sub_Weight: count,
        Event_Sum: score,
        Sub_Coint: count * score,
        Type_Weight: idWeight,
        Type_Weight_Title: titleWeight,
        Icon: icon,
        MinWeight: minweight,
      })
      setLstarray(lstarray)
    }
    else if (val === false) {
      var l=(lstarray.filter((i) => i.Type_Trash !== id))
      setLstarray(l)
    }

  }

  const AddCounter = (id, val) => {
    const indx = lstarray.findIndex((i) => i.Type_Trash === id);

    lstarray[indx].Sub_Weight = parseFloat(val);
    lstarray[indx].Sub_Coint = parseFloat(lstarray[indx].Event_Sum * lstarray[indx].Sub_Weight);

    if (Stchange)
      setstchange(false)
    else
      setstchange(true)


  }


  const submitHandler = () => {
    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را انتخاب کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setFormIsValid("2")
    }
  }

  const newItemsHandler = () => {
    setFormIsValid("1");
  }

  const removeHandler = (id) => {
   const l = lstarray.filter((i) => i.Type_Trash !== id)
   setLstarray(l)
    if (Stchange)
      setstchange(false)
    else
      setstchange(true)

  }




  useEffect(() => {

    if (userToken === null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "GetList_Trash")
        .then((res) => {

          if (res.data.result === "true") {
            setSeenFile(res.data.data);
            setMinSum(res.data.MinSum);
          } else {
          }
        });

      if (order !== orderchange && order !== 0) {
        setFormIsValid("2")
        axios
          .post(apiUrl + "Edit_Request", {
            TokenId: userToken,
            Orderid: order,
          })
          .then((res) => {
            if (res.data.result === "true") {
              setLstarray(res.data.data);
              console.log(res.data.data);
              master[0].orderid = order
              setOrderchange(order)
            }
          });
      }
    }
  }, [Stchange, toggle]);


  const driverHandler = () => {


    if (lstarray.length <= 0) {
      toast.error("لطفا پسماندهای مورد نظر را اضافه کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      master[0].weight = 0;
      master[0].coint = 0;
      for (let i = 0; i < lstarray.length; i++) {
        master[0].weight += lstarray[i].Sub_Weight
        master[0].coint += lstarray[i].Sub_Coint
      }
      // for (let i = 0; i < lstarray.length; i++) {
      //   master[0].weight += lstarray[i].count
      //   master[0].coint += lstarray[i].Sum
      // }
      if (master[0].coint < minSum) {
        toast.error("مجموع مبلغ پسماندها باید از حداقل مبلغ تعیین شده بیشتر باشد", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return false
      } else {
      }
      console.log(JSON.stringify(lstarray))
      console.log(JSON.stringify(master))
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Edit_Orders_By_Dr", {
          ldetails: JSON.stringify(lstarray),
          lmaster: JSON.stringify(master),
          TokenId: userToken,
          Code_Meli: "",
        })

        .then((res) => {
          setSnip(false);
          console.log(res.data.result)
          if (res.data.result === "true") {
            setMaster([{ weight: 0, coint: 0, orderid: order }])
            setLstarray([])
            toast.success(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            navigate(`../dashboard/${order}`)

          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }


  return (
    <>
      <BottomSheet
        order={order}
        open={toggle}
        onDismiss={toggleHandler1}
        initialFocusRef={false}
        expandOnContentDrag
      >
        <div>
          <Container>
            <div className="rgc-close-icon">
            <i class="fa-regular fa-circle-xmark" onClick={toggleHandler1}></i>
            </div>
            <Row className="justify-content-center">

              <Col xs={12} lg={8} className="p-4 mb-4">

                {/* first-part */}
                <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                  <Row className="rgc-orderform gx-5 gy-3">

                    <Col xs={12}>
                      <div className="d-flex rgc-title">
                        <div className="rgc-title-point"></div>
                        <h4>ثبت <span>سفارش</span></h4>
                      </div>
                    </Col>
                    {seenFile.map((data, index) => {
                      return (
                        <Col key={index} xs={12} md={6}>
                          <Row className="justify-content-center  rgc-station-time">
                            <Col xs={2}>
                              <Form.Group controlId="formBasicCheckbox">
                                {lstarray.findIndex((i) => i.Type_Trash === data.Trashd) >= 0 ?
                                  <Form.Check
                                    checked={true}
                                    key={key}
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, data.MinWeight)}
                                  /> :
                                  <Form.Check
                                    key={key}
                                    inline
                                    name="group1"
                                    type="checkbox"
                                    id={index}
                                    onChange={(e) =>
                                      AddListState(e.target.checked, data.Tittle, data.Trashd, 0.5,
                                        data.Event_Sum, data.Type_Weight, data.Type_Weight_Tittle,
                                        data.Icon, data.MinWeight)}
                                  />
                                }
                              </Form.Group>
                            </Col>

                            <Col xs={2} className="text-center">
                              <Image src={IPUrl + data.Icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={8} className="text-end">
                              <span>{data.Tittle} </span>
                            </Col>

                            <Col xs={12} className="text-start">
                              <span>مبلغ پایه:</span>
                              <span>{Intl.NumberFormat('en-US').format(data.Event_Sum)}&nbsp;ریال </span>
                            </Col>
                          </Row>

                        </Col>
                      )
                    })}

                    <Col className="rgc-order-content">
                      <Row className="justify-content-center">
                        <Col xs={5} sm={3} className="text-center">
                          <Button className="rgc-order-btn rgc-order-btn-sub" onClick={submitHandler}>
                            مرحله بعد
                          </Button>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </div>

                {/* secound-part */}
                <div className={formIsValid === "2" ? "d-block" : "d-none"}>

                  <Row className="gx-5 gy-3 rgc-order-items">
                    {lstarray.map((item, index) => {
                      return (

                        <Col xs={12} key={index} md={6}>
                          <Row className="justify-content-around  rgc-station-time">

                            <Col xs={2} className="rgc-order-close">
                              <i class="fa-solid fa-circle-xmark" onClick={() => removeHandler(item.Type_Trash)}></i>
                            </Col>

                            <Col xs={4} className="text-start">
                              <Image src={IPUrl + item.Icon} alt="" className="rgc-image" />
                            </Col>

                            <Col xs={6} className="text-end rgc-order-title">
                              <span> {item.Type_Trash_Tittle}</span>
                            </Col>
                            <hr className="w-75" />
                            <Col xs={12}>
                              <Form.Group className="row g-0 align-items-center justify-content-center" controlId="formBasicEmail">

                                <Col xs={7}>
                                  {/* <CounterInput
                                    value={item.Sub_Weight}
                                    min={1}
                                    onChange={(value) => { AddCounter(item.Type_Trash, value) }} /> */}
                                  <NumericInput
                                    step={0.5}
                                    precision={1}
                                    min={0.5}
                                    value={parseFloat(item.Sub_Weight)}
                                    mobile
                                    onChange={(value) => {AddCounter(item.Type_Trash, value) }}
                                  />
                                </Col>

                                <Col xs={3} className="rgc-order-label text-center">
                                  <Form.Label className="m-0">{item.Type_Weight_Title}</Form.Label>
                                </Col>
                              </Form.Group>
                            </Col>

                            <Col xs={9} className="rgc-driver-txt text-center my-2">
                              <div className="d-flex flex-column justify-content-center">
                                <div className="rgc-order-span">
                                  <span>مبلغ پایه:</span>
                                  <span>{Intl.NumberFormat('en-US').format(item.Event_Sum)}&nbsp;ریال </span>
                                </div>

                                <div className="rgc-order-span">
                                  <span>جمع مبلغ:</span>
                                  <span>{Intl.NumberFormat('en-US').format(item.Sub_Coint)}&nbsp;ریال </span>
                                </div>

                              </div>
                            </Col>
                          </Row>

                        </Col>
                      )
                    }
                    )}
                  </Row>

                  <Row>
                    <Col xs={12} className="rgc-order-icon">
                      <i class="fa fa-plus-circle" aria-hidden="true" onClick={newItemsHandler}></i>
                    </Col>

                    <Row>
                      <Col className="rgc-order-content">
                        <Row className="justify-content-center">
                          <Col xs={12} className="text-center rgc-order-score">
                            <span>حداقل مبلغ برای ثبت سفارش باید {Intl.NumberFormat('en-US').format(minSum)} ریال باشد</span>
                            <span>مجموع  مبالغ :{Intl.NumberFormat('en-US').format(lstarray.reduce((acc, item) => acc + item.Sub_Weight * item.Event_Sum, 0))}&nbsp;ریال </span>
                            <span>مجموع کل وزن :{(lstarray.reduce((acc, item) => acc + item.Sub_Weight * item.Type_Weight, 0)).toFixed(1)}</span>
                          </Col>

                          {/* <Col xs={4} sm={3} className="text-center">
                            <Button onClick={toggleHandler1} className="rgc-order-btn rgc-order-btn-cancel">
                              بستن
                            </Button>
                          </Col> */}

                          <Col xs={4} md={3} className="text-center" onClick={toggleHandler1}>
                            <Button className="rgc-order-btns  rgc-order-btn-sub" onClick={driverHandler} >
                              <Loaders loads={snip} />
                              ثبت نهایی
                            </Button>
                          </Col>

                        </Row>

                      </Col>
                    </Row>



                  </Row>
                </div>

              </Col>
            </Row>

          </Container>

        </div>
      </BottomSheet>
    </>

  );
}

export default OrderForm;
